/**
 * Base-map "places" (Google POI) presets for the device map.
 *
 * Google ignores the runtime `styles` option on a map with a map ID, and
 * the device map needs a map ID for its advanced markers. Hiding Google's
 * POIs therefore uses cloud-based map styling: each preset is its own map
 * ID (Google Cloud Console → Map management, JavaScript, linked to a map
 * style with the listed points of interest turned off, with light and dark
 * variants). Switching preset re-creates the map with that map ID.
 *
 * A preset whose map ID is not configured yet is shown disabled.
 * REACT_APP_* variables override the built-in IDs at build time.
 */

const env = (name) => (typeof process !== 'undefined' && process.env && process.env[name]) || '';

export const MAP_PLACES_PRESETS = [
  {
    id: 'all',
    label: 'All places',
    help: "Google's default points of interest",
    mapId: env('REACT_APP_DEVICE_MAP_ID') || 'NETWORK_MANAGER_MAP',
  },
  {
    id: 'no-business',
    label: 'Hide businesses',
    help: 'Hotels, shops, restaurants, gas stations; keeps parks, transit, schools',
    mapId: env('REACT_APP_DEVICE_MAP_ID_NO_BUSINESS'),
  },
  {
    id: 'none',
    label: 'Hide all places',
    help: 'No points of interest or transit icons; streets only',
    mapId: env('REACT_APP_DEVICE_MAP_ID_NO_POI'),
  },
];

const STORAGE_KEY = 'nms.deviceMap.placesPreset';
const DEFAULT_PRESET = MAP_PLACES_PRESETS[0];

export function isPresetAvailable(preset) {
  return Boolean(preset?.mapId);
}

/** The preset for an id, falling back to the default when unknown or not configured. */
export function resolvePlacesPreset(id) {
  const preset = MAP_PLACES_PRESETS.find((p) => p.id === id);
  return isPresetAvailable(preset) ? preset : DEFAULT_PRESET;
}

export function readStoredPlacesPreset() {
  try {
    return resolvePlacesPreset(window.localStorage.getItem(STORAGE_KEY));
  } catch (e) {
    return DEFAULT_PRESET;
  }
}

export function storePlacesPreset(id) {
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch (e) {
    // Per-viewer convenience only.
  }
}
